/**
 * Detaljer › Påminnelser (molnfast-react#1613): a summary of the order's
 * reminder schedule for its external delegates. The schedule is edited, and
 * the sent reminders are listed, in WorkOrderRemindersModal.
 */
import React from 'react';
import { Button } from 'react-bootstrap';
import { Bell } from 'lucide-react';
import WorkOrderRemindersModal from './WorkOrderRemindersModal';
import { DetailLabel } from '../../Pages/WorkOrders/components/shared/DetailsList';
import { useReminderScheduleEditor } from '../../hooks/workOrders/useReminderScheduleEditor';
import type { WorkOrder } from '../../types/workOrders';
import { describeReminderTiming, parseReminderLog, scheduleTiming } from '../../types/workOrderReminders';

interface WorkOrderRemindersDetailProps {
    workOrder: Pick<WorkOrder, 'key' | 'buildingKey' | 'title' | 'dueDate' | 'reminders'>;
    /** Admin and the order is open */
    canEdit: boolean;
    nameOf: (uid: string) => string;
    onSaved: () => void;
}

const WorkOrderRemindersDetail: React.FC<WorkOrderRemindersDetailProps> = ({ workOrder, canEdit, nameOf, onSaved }) => {
    const editor = useReminderScheduleEditor(workOrder, onSaved);
    const timing = scheduleTiming(workOrder.reminders?.schedule);
    const sentCount = parseReminderLog(workOrder.reminders?.sent).length;

    return (
        <>
            <DetailLabel
                icon={Bell}
                label="Påminnelser"
                onEdit={canEdit ? editor.start : undefined}
                empty={!timing}
            />
            <div>{describeReminderTiming(timing)}</div>
            {timing && !workOrder.dueDate && (
                <small className="text-warning d-block mt-1">Inget förfallodatum – inga påminnelser skickas.</small>
            )}
            {sentCount > 0 && (
                <Button variant="link" className="wo-edit-link p-0" onClick={editor.view}>
                    {sentCount} skickade
                </Button>
            )}
            <WorkOrderRemindersModal
                show={editor.open}
                workOrder={workOrder}
                canEdit={canEdit}
                nameOf={nameOf}
                draft={editor.draft}
                onDraftChange={editor.setDraft}
                saving={editor.saving}
                error={editor.error}
                onSave={() => { void editor.save(); }}
                onHide={editor.cancel}
            />
        </>
    );
};

export default WorkOrderRemindersDetail;
